import { required, minValue } from 'vuelidate/lib/validators'

export const contractValidators = {
    required,
    minValue,

    cnpj: (value) => {
        if (!value) return true
        const digits = value.replace(/\D/g, '')
        return digits.length === 14
    },

    dateNotFuture: (value) => {
        if (!value) return true
        const [dd, mm, yyyy] = String(value).split('/')
        if (!dd || !mm || !yyyy) return true
        const date = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd))
        const today = new Date()
        return date <= today
    },

    dateRange: (startDate, endDate) => {
        if (!startDate || !endDate) return true
        const [dd1, mm1, yyyy1] = String(startDate).split('/')
        const [dd2, mm2, yyyy2] = String(endDate).split('/')
        if (!dd1 || !mm1 || !yyyy1 || !dd2 || !mm2 || !yyyy2) return true
        const start = new Date(
            parseInt(yyyy1),
            parseInt(mm1) - 1,
            parseInt(dd1)
        )
        const end = new Date(parseInt(yyyy2), parseInt(mm2) - 1, parseInt(dd2))
        return start <= end
    }
}
